//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

require('intersection-observer')
import { useLogger, useToast } from '~/utils/functions/common'
import { useFavorite } from '~/composables'
import lozad from 'lozad'
import {
  FormatSalaryType,
  formatSideSalary,
  formatSideWorkStyle,
} from '~/utils/functions/format/job_offer'
import {
  defineComponent,
  reactive,
  computed,
  useStore,
  onMounted,
  nextTick,
  toRefs,
  useRoute,
} from '@nuxtjs/composition-api'

export default defineComponent({
  props: {
    type: {
      type: String,
      default: '',
    },
    userOffer: {
      type: Object,
      default: () => {},
    },
    jobOffer: {
      type: Object,
      default: () => {},
    },
    positionNumber: {
      type: Number,
      default: 0,
    },
  },
  setup(props, context) {
    const store = useStore(),
      route = useRoute(),
      state = reactive({
        modal: false,
        isFavorite: true,
        likeBtnClickCount: 0,
        dislikeBtnClickCount: 0,
        circleBeforeStyle: {
          transform: 'rotate(0deg)',
        },
        circleAfterStyle: {
          transform: 'rotate(0deg)',
        },
        isSideBusiness: false,
        imgixSize: 0.5,
        isPC: false,
      }),
      logger = useLogger(),
      toast = useToast(),
      favorite = useFavorite()

    // computed
    const FormatSalary = computed(() => {
      const { max_salary, min_salary } = props.jobOffer
      let formatSalary = ''
      if (max_salary && min_salary) {
        formatSalary = String(min_salary) + '万〜' + String(max_salary) + '万円'
      } else if (!max_salary && min_salary) {
        formatSalary = String(min_salary) + '万〜'
      } else if (!min_salary && max_salary) {
        formatSalary = '〜' + String(max_salary) + '万円'
      }
      return formatSalary
    })

    const SalaryType = computed(() => {
      const { salary_type } = props.jobOffer
      if (salary_type === 'hourly_payment') return '時給'
      if (salary_type === 'monthly_payment') return '月額'
      return '固定'
    })

    const FormatPrefecture = computed(() => {
      if (props.jobOffer.company.prefecture) {
        return props.jobOffer.company.prefecture
      } else {
        return ''
      }
    })

    const FormatIndustryAndOccupation = computed(() => {
      let str = ''
      var industry = store.state.masterData.industries.find(
        (el) => el.id == props.jobOffer.company.industry_id
      )
      if (industry !== void 0) {
        str += industry.name
      } else if (props.jobOffer.company.industry) {
        str += props.jobOffer.company.industry.name
      }
      var occupation = store.state.masterData.jobPositions.find(
        (el) => el.id == props.jobOffer.job_position_id
      )
      if (occupation !== void 0) {
        str += '/' + occupation.name
      } else if (props.jobOffer.job_position) {
        str += '/' + props.jobOffer.job_position.name
      }
      return str
    })

    const FormatWorkStyle = computed(() => {
      const { work_style } = props.jobOffer
      if (work_style === 'office_work') return '主に出社'
      if (work_style === 'partly_remote_work') return '一部テレワーク'
      if (work_style === 'full_remote_work') return '完全テレワーク'
      return '規定なし'
    })

    const isLoggedIn = computed(() => {
      const { session, clientProfile } = store.state.user || {}
      return session && session.access_token && clientProfile && clientProfile.id
    })

    const isHistory = computed(() => {
      if (route.name === 'browsing_history') return true
      return false
    })

    // onMounted
    onMounted(() => {
      const width = window.innerWidth
      state.isPC = width > 641 ? true : false
      if (!state.isPc) {
        state.imgixSize = 0.3
      }
      // 副業求人判定
      const { salary_type } = props.jobOffer || {}
      if (salary_type) state.isSideBusiness = true

      nextTick(() => {
        const { is_favorite_job_offer } = props.jobOffer || {}
        state.isFavorite = is_favorite_job_offer ? true : false
        setObserver()
      })
    })

    // methods
    const handleClickJobOffer = () => {
      /* 求人リンククリック時の計測 */
      // 求人一覧のみ（応募一覧、閲覧履歴などを除く）
      if (props.type === 'recommend') {
        const pageNumber = route.value.query.page || 1
        logger.post('click_recommend_job_offer', {
          position: state.positionNumber,
          job_offer_id: props.jobOffer.id,
          page: pageNumber,
        })
      }
    }

    const setObserver = () => {
      // acropolis ipression送信の設定
      const observer = lozad('.lozad', {
        threshold: 0.5,
        load: (el) => {
          // 要素取得
          const targetItems = document.getElementsByClassName('recommend-detail')
          // 配列化
          const targetItemsArray = Array.from(targetItems)
          // 要素の並び順取得（0~49）
          const targetItemNum = targetItemsArray.indexOf(el)
          // 要素のid取得
          const targetItemId = el.getAttribute('id')
          // ページ番号
          const pageNumber = route.value.query.page || 1
          // impression送信
          logger.post('impression', {
            position: targetItemNum + 1,
            model_id: targetItemId,
            page: pageNumber,
          })
        },
      })
      // 画像遅延ロードの設定
      const imgObserver = lozad('.lozadImg', {
        threshold: 0.1,
        load: (el) => {
          // 画像遅延ロード処理
          const target = el.getElementsByClassName('img-gallery-img')
          const targetArray = Array.from(target)
          // 企業ロゴ
          const targetLogo = el.getElementsByClassName('item-img')
          const targetLogoArray = Array.from(targetLogo)
          // 画像がある時のみ
          if (targetArray.length) {
            targetArray.forEach((img) => {
              // display noneでない場合のみ画像をセット
              if (document.defaultView.getComputedStyle(img, null).display !== 'none') {
                const backgroundImage = img.children[0].dataset.src
                img.children[0].style.backgroundImage = backgroundImage
              }
            })
          }
          if (targetLogoArray) {
            targetLogoArray.forEach((logo) => {
              // display noneでない場合のみ画像をセット
              if (document.defaultView.getComputedStyle(logo, null).display !== 'none') {
                const backgroundImage = logo.dataset.src
                logo.style.backgroundImage = backgroundImage
              }
            })
          }
        },
      })
      // 0.5秒待ってから実行（画像読み込み待ち）
      setTimeout(() => {
        // observer実行
        observer.observe()
        imgObserver.observe()
      }, 500)
    }

    const like = async () => {
      /* 後でみる */
      // 二度押し抑制
      if (state.likeBtnClickCount === 0) {
        state.likeBtnClickCount++

        if (props.userOffer && props.userOffer.job_offer_id) {
          const { job_offer_id } = props.userOffer
          const resLike = await store.dispatch('scout/putFavoriteScout', {
            id: job_offer_id,
          })
          if (resLike.code === 200) {
            state.isFavorite = true
            favorite.changeState(true, props.userOffer.job_offer_id)
            logger.post('read_later', { job_offer_id: props.userOffer.job_offer_id })
          } else {
            toast.showError('エラーが発生しました', context)
          }
        } else {
          toast.showError('エラーが発生しました', context)
        }

        setTimeout(() => (state.likeBtnClickCount = 0), 1000)
      }
    }

    const removeLike = async () => {
      /* 後でみる解除 */
      // 二度押し抑制
      if (state.dislikeBtnClickCount === 0) {
        state.dislikeBtnClickCount++

        if (props.userOffer && props.userOffer.job_offer_id) {
          const { job_offer_id } = props.userOffer
          await store.dispatch('scout/deleteFavoriteScout', {
            id: job_offer_id,
          })
          state.isFavorite = false
          favorite.changeState(false, props.userOffer.job_offer_id)
          logger.post('release_read_later', { job_offer_id: props.userOffer.job_offer_id })
        } else {
          toast.showError('エラーが発生しました', context)
        }

        setTimeout(() => (state.dislikeBtnClickCount = 0), 1000)
      }
    }

    return {
      ...toRefs(state),
      FormatSalaryType,
      formatSideSalary,
      formatSideWorkStyle,
      FormatSalary,
      SalaryType,
      FormatPrefecture,
      FormatIndustryAndOccupation,
      FormatWorkStyle,
      isLoggedIn,
      isHistory,
      handleClickJobOffer,
      like,
      removeLike,
    }
  },
})
